import api from '../utils/api';

export const getAllUsers = async () => {
    try {
        const response = await api.get('/users');
        return response.data;
    } catch (error) {
        throw error.response ? error.response.data : new Error('Failed to fetch users');
    }
};

export const getUserById = async (id) => {
    try {
        const response = await api.get(`/users/${id}`);
        return response.data;
    } catch (error) {
        throw error.response ? error.response.data : new Error('Failed to fetch user');
    }
};

export const getUsersByRole = async (roleName) => {
    try {
        // Enlever le préfixe 'ROLE_' si présent
        const formattedRole = roleName.startsWith('ROLE_')
            ? roleName.substring(5) // Enlever 'ROLE_'
            : roleName;

        const response = await api.get(`/users/role/${formattedRole}`);
        return response.data;
    } catch (error) {
        console.error(`Erreur lors de la récupération des utilisateurs avec le rôle ${roleName}:`, error);
        throw new Error(error.response?.data?.message || 'Impossible de récupérer les utilisateurs par rôle');
    }
};

export const createUser = async (userData, roleTypes) => {
    try {
        const { roles, ...userOnly } = userData;
        const response = await api.post('/users', {
            user: userOnly,
            roleTypes: roles
        });
        return response.data;
    } catch (error) {
        throw error.response ? error.response.data : new Error('Failed to create user');
    }
};

export const updateUser = async (id, userData) => {
    try {
        const response = await api.put(`/users/${id}`, userData);
        return response.data;
    } catch (error) {
        throw error.response ? error.response.data : new Error('Failed to update user');
    }
};

export const deleteUser = async (id) => {
    try {
        const response = await api.delete(`/users/${id}`);
        return response.data;
    } catch (error) {
        throw error.response ? error.response.data : new Error('Failed to delete user');
    }
};

export const changePassword = async (id, oldPassword, newPassword) => {
    try {
        const response = await api.post(`/users/${id}/change-password`, {
            oldPassword,
            newPassword
        });
        return response.data;
    } catch (error) {
        throw error.response ? error.response.data : new Error('Failed to change password');
    }
};

export const updateUserRoles = async (id, roleTypes) => {
    try {
        const response = await api.put(`/users/${id}/roles`, roleTypes);
        return response.data;
    } catch (error) {
        throw error.response ? error.response.data : new Error('Failed to update user roles');
    }
};